import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';

import { Color, Tile, TILE_TOKEN, TileId, TileType, TRANSLATION_NS } from '@contact/upgrade';

import { WALLBOARD_GUARDS } from './wallboard.guard';

@NgModule({})
export class WallboardForRootModule {
  constructor(@Optional() @SkipSelf() parentModule: WallboardForRootModule) {
    if (parentModule) throw new Error(`[WallboardForRootModule] module is already loaded`);
  }

  static instance(options: { path: string }): ModuleWithProviders<WallboardForRootModule> {
    return {
      ngModule: WallboardForRootModule,
      providers: [
        WALLBOARD_GUARDS,
        {
          provide: TILE_TOKEN,
          useValue: {
            id: TileId.WALLBOARD_CUSTOM,
            type: TileType.STANDARD,
            icon: 'tile_wallboard',
            color: Color.BLUE,
            platforms: {
              desktop: {
                path: options.path,
              },
            },
            activePlatform: 'desktop',
          } as Tile,
          multi: true,
        },
        {
          provide: TRANSLATION_NS,
          useValue: 'wallboard',
          multi: true,
        },
      ],
    };
  }
}
